import { Button, Typography } from "@povio/ui";
import Image from "next/image";
import type { FC } from "react";

import BackgroundImage from "@/assets/images/project/bg.png";
import LaptopImage from "@/assets/images/project/laptop.png";
import { ProjectFormModal } from "@/components/home/modals/ProjectFormModal";
import { DemoClickWrapper } from "@/components/shared/demo/DemoClickWrapper";
import { TourSelectors } from "@/config/tour.config";
import { DemoContext } from "@/providers/demo/DemoContext";

interface Props {
  onAddProject: () => void;
  isModalOpen: boolean;
  closeProjectModal: () => void;
  onProjectSaved?: () => void;
}

const EmptyProjectSection: FC<Props> = ({ onAddProject, isModalOpen, closeProjectModal, onProjectSaved }) => {
  const { isDemoMode } = DemoContext.useDemo();

  return (
    <div
      style={{ backgroundImage: `url(${BackgroundImage.src})` }}
      className="relative flex h-[466px] w-full flex-col items-center justify-center gap-4 t:overflow-hidden rounded-xl bg-cover bg-no-repeat"
      id={TourSelectors.ProjectsSection}
    >
      <div className="flex m:flex-row flex-col m:items-end items-center justify-center gap-4 m:gap-10">
        <Image
          src={LaptopImage}
          alt="Laptop"
          width={380}
          height={211}
          className="m:px-0 px-4"
        />
        <div className="flex max-w-[223px] m:-translate-y-10 flex-col items-center justify-center gap-4">
          <Typography
            size="body-1"
            variant="prominent-2"
            className="m:text-left text-center text-secondary-75 leading-6"
          >
            Your <span className="text-primary">Projects</span> section is currently empty.
          </Typography>
          <DemoClickWrapper>
            <Button
              color="secondary"
              size="s"
              isDisabled={isDemoMode}
              onPress={onAddProject}
              className="w-full px-[24px]! py-[9px]! text-label-1!"
            >
              Upload Your Projects
            </Button>
          </DemoClickWrapper>
        </div>
      </div>
      {isModalOpen && (
        <ProjectFormModal
          isOpen={isModalOpen}
          onClose={closeProjectModal}
          isFirstProject
          onProjectSaved={onProjectSaved}
        />
      )}
    </div>
  );
};

export default EmptyProjectSection;
